/* tslint:disable */
/* eslint-disable */
/* @relayHash 9bb85993f0b9a04c8215a689498f8e61 */

import { ConcreteRequest } from "relay-runtime";
export type userTrackingQueryVariables = {
    hasCheckoutUserId: boolean;
    checkoutUserId: string;
    hasUserId: boolean;
    isLoggedIn: boolean;
    userId: string;
};
export type userTrackingQueryResponse = {
    readonly viewer: {
        readonly transactionsCounter?: {
            readonly submittedTransactions?: number | null;
            readonly confirmedTransactions?: number | null;
            readonly guestCheckoutTransactions: number | null;
        } | null;
        readonly user?: {
            readonly isVerifiedTrade: boolean | null;
        } | null;
    };
};
export type userTrackingQuery = {
    readonly response: userTrackingQueryResponse;
    readonly variables: userTrackingQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "checkoutUserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasCheckoutUserId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLoggedIn"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v5 = {
  "condition": "hasCheckoutUserId",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "checkoutUserId"
        }
      ],
      "concreteType": "TransactionsCounter",
      "kind": "LinkedField",
      "name": "transactionsCounter",
      "plural": false,
      "selections": [
        {
          "alias": "guestCheckoutTransactions",
          "args": null,
          "kind": "ScalarField",
          "name": "guest",
          "storageKey": null
        },
        {
          "condition": "hasUserId",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "submittedTransactions",
              "args": null,
              "kind": "ScalarField",
              "name": "submitted",
              "storageKey": null
            },
            {
              "alias": "confirmedTransactions",
              "args": null,
              "kind": "ScalarField",
              "name": "confirmed",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ]
},
v6 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVerifiedTrade",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "userTrackingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "condition": "isLoggedIn",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "userTrackingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v5/*: any*/),
          {
            "condition": "isLoggedIn",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/316.0.0-2021-05-20T20:01:12.438Z/userTrackingQuery",
    "metadata": {},
    "name": "userTrackingQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = '2e221747b7b26afdf87834db0b530298';
export default node;
